export default __webpack_public_path__ + "static/media/kamivest_logo.f19cba2b.svg";